import React, { useContext, useEffect } from 'react'
import { store } from '../../stores/graphics_menu'
import LoadingIndicator from '../shared/LoadingIndicator'
import GraphicNext from '../GraphicNext'

export default function Search() {
  const { loading, graphics, dispatch, actions, selectedGraphics, uploadMenuState } = useContext(store)

  useEffect(() => {
    if (graphics == null) {
      dispatch({ type: actions.LOAD_GRAPHICS})
    }
  }, [graphics])

  const handleClick = (graphic) => {
    dispatch({ type: actions.SELECT_GRAPHIC, payload: graphic })
  }

  return (
    <LoadingIndicator loading={loading}>
      <div className="graphic-container">
        {graphics && graphics.map(graphic => {
          const isSelected = selectedGraphics.map(graphic => graphic.id.toString()).includes(graphic?.id.toString())
          return (
            <GraphicNext
              graphic={graphic}
              key={`graphic:${graphic.id}`}
              selected={isSelected}
              multi={uploadMenuState?.multi}
              onClick={() => handleClick(graphic)} />
          )
        })}
      </div>
    </LoadingIndicator>
  )
}
